.panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-2xl);
}

.intro {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.prompt {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 700;
}

.status {
  min-height: 1.5rem;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.problem {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-feedback-warning-text);
}

.result {
  margin: 0;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 700;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
  align-items: center;
}

.readout {
  margin: 0;
  font-family: var(--tuna-typography-mono-fontFamily);
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
  font-variant-numeric: tabular-nums;
}
